// extracted by mini-css-extract-plugin
export default {"table_annotationsHeading":"AllUserTable_table_annotationsHeading__RlpEV","table":"AllUserTable_table__rOSrs","tableCol_infoIcon":"AllUserTable_tableCol_infoIcon__vd4w6"};